function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_23817",
  fill: "#6e6e6f",
  d: "M23.928 5.334V6.1c0 7.315-5.487 15.545-15.546 15.545A15.854 15.854 0 0 1 0 19.2h1.372a11.938 11.938 0 0 0 6.858-2.283 5.593 5.593 0 0 1-5.182-3.81c.3 0 .61.152 1.067.152a4.22 4.22 0 0 0 1.372-.152 5.559 5.559 0 0 1-4.42-5.487 6.529 6.529 0 0 0 2.439.762A5.188 5.188 0 0 1 1.067 3.81a5.263 5.263 0 0 1 .762-2.743 15.9 15.9 0 0 0 11.278 5.639c0-.457-.152-.762-.152-1.219A5.464 5.464 0 0 1 18.441 0 5.284 5.284 0 0 1 22.4 1.676 7.973 7.973 0 0 0 25.909.457a5.93 5.93 0 0 1-2.439 3.048 12.652 12.652 0 0 0 3.2-.914 11.72 11.72 0 0 1-2.742 2.743z",
  "data-name": "Path 23817"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter",
    width: 26.671,
    height: 21.641,
    viewBox: "0 0 26.671 21.641",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.595b3462.svg";
export { ForwardRef as ReactComponent };